<section>
  <div class="stellar-block">
    <div class="container flex justify-content-center">
      <div class="lg:w-8 text-justify p-4">
        <h1>Política de Privacidad</h1>

        @if (pageData.sections.length > 0) {
          @for (section of pageData.sections; track section.id) {
            @if (section.title) {
              <h2>{{ section.title }}</h2>
            }
            <div [innerHTML]="section.description"></div>
          }
        } @else {
          <p>
            La política de privacidad se encuentra en proceso de actualización.
            Por favor, vuelva a consultar esta página próximamente para obtener
            la información más reciente.
          </p>
        }
      </div>
    </div>
  </div>
</section>
